import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { StringComparatorMultiEditor } from '@leverege/ui-attributes';
import EnumEqualsComparator from "./EnumEqualsComparator.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function EnumEqualsComparatorEditor(props) {
  const {
    value,
    usage,
    variant,
    suggestor
  } = props;
  const value1 = EnumEqualsComparator.getValue1(value);
  const onModelChange = useValueChange(EnumEqualsComparator, props);
  return /*#__PURE__*/_jsx(StringComparatorMultiEditor, {
    usage: usage,
    selectionType: "text",
    allowCreate: false,
    variant: variant,
    suggestor: suggestor,
    value: value1,
    eventData: "setValue1",
    onChange: onModelChange
  });
}
EnumEqualsComparatorEditor.isInline = true;